import * as XLSX from "xlsx";
import toast from "react-hot-toast";

/**
 * Generates and downloads the Excel template for bulk customer uploads.
 */
export const downloadCustomerTemplate = () => {
  const headers = [
    "First Name",
    "Last Name",
    "Phone Number",
    "Email Address",
    "Address Line 1",
    "Address Line 2",
    "City",
    "District",
    "State",
    "PIN Code",
    "Office Location",
    "Reference Type",
    "Referral Name / Details",
    "Requirement Type",
    "Type",
    "Estimated Budget",
    "Notes"
  ];

  const sampleData = [
    {
      "First Name": "John",
      "Last Name": "Doe",
      "Phone Number": "9876543210",
      "Email Address": "john.doe@example.com",
      "Address Line 1": "123 Premium Lane",
      "Address Line 2": "Suite 500",
      "City": "Mumbai",
      "District": "Mumbai City",
      "State": "Maharashtra",
      "PIN Code": "400001",
      "Office Location": "Main HQ",
      "Reference Type": "Google",
      "Referral Name / Details": "Self search",
      "Requirement Type": "Residential",
      "Type": "3 BHK",
      "Estimated Budget": "500000",
      "Notes": "Looking for premium modular kitchen and living room interior work."
    }
  ];

  try {
    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });

    // Set column widths
    const wscols = headers.map(() => ({ wch: 22 }));
    ws['!cols'] = wscols;

    const instructionRows = [
      { Rule: "Required columns", Value: "First Name, Phone Number, City, State" },
      { Rule: "Phone Number format", Value: "Must be exactly 10 digits, numbers only (starts with 6-9)" },
      { Rule: "Phone Number uniqueness", Value: "Phone Number must be unique across the entire system" },
      { Rule: "Supported files", Value: ".xlsx, .xls, .csv" },
      { Rule: "Optional columns", Value: "Last Name, Email Address, Address Line 1, Address Line 2, District, PIN Code, Notes..." }
    ];

    const instructionSheet = XLSX.utils.json_to_sheet(instructionRows, { header: ["Rule", "Value"] });
    instructionSheet['!cols'] = [{ wch: 24 }, { wch: 70 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Customers Template");
    XLSX.utils.book_append_sheet(wb, instructionSheet, "Instructions");

    XLSX.writeFile(wb, "Verve_Customers_Template.xlsx");
    toast.success("Template downloaded!");
  } catch (error) {
    console.error("XLSX Template Download Error:", error);
    toast.error("Failed to download template. Please try again.");
  }
};

/**
 * Exports an array of contact records to Excel.
 * @param {Array} contacts 
 */
export const downloadContactsAsExcel = (contacts) => {
  if (!contacts || contacts.length === 0) {
    toast.error("No data to export");
    return;
  }

  try {
    const data = contacts.map(c => ({
      'Verve ID': (c.customId || "").toUpperCase(),
      'First Name': c.firstName || "",
      'Last Name': c.lastName || "",
      'Phone Number': c.phoneNumber || "",
      'Email Address': c.email || "",
      'Address Line 1': c.addressLine1 || "",
      'Address Line 2': c.addressLine2 || "",
      'City': c.city || "",
      'District': c.district || "",
      'State': c.state || "",
      'PIN Code': c.pincode || "",
      'Office Location': c.officeLocation || "",
      'Reference Type': c.referenceType || "",
      'Referral Name / Details': c.referenceDetails || "",
      'Requirement Type': c.requirementType || "",
      'Type': c.propertyType || "",
      'Estimated Budget': c.budget || 0,
      'Telecaller Name': c.telecaller?.name || c.telecaller || "Unassigned",
      'Sales Executive / Assigned To': c.salesPerson?.name || c.assignedTo?.name || c.salesPerson || c.assignedTo || "Unassigned",
      'Contact Status': c.status || "",
      'Telecaller Status': c.teleStatus || "",
      'Lead Status': c.leadStatus || "",
      'Source': c.source || "",
      'Created Date': c.createdAt ? new Date(c.createdAt).toLocaleDateString() : "",
      'Last Updated Date': c.updatedAt ? new Date(c.updatedAt).toLocaleDateString() : "",
      'Floor Details': c.floorDetails || "",
      'Quoted Amount': c.quotationAmount || "",
      'Recommended Capacity': c.verveCapacityRequested || c.VerveCapacityRequested || "",
      'Notes': c.notes || ""
    }));

    const ws = XLSX.utils.json_to_sheet(data);

    // Set column widths
    const headers = Object.keys(data[0]);
    const wscols = headers.map(() => ({ wch: 20 }));
    ws['!cols'] = wscols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Contacts");
    XLSX.writeFile(wb, `Verve_Contacts_Export_${new Date().toLocaleDateString().replace(/\//g, '-')}.xlsx`);
    toast.success("Contacts exported!");
  } catch (error) {
    console.error("Export Error:", error);
    toast.error("Failed to export contacts");
  }
};
